import useUpdateExaminationPaper from './useUpdateExaminationPaper';

export default useUpdateExaminationPaper;
